import { createAction, props } from '@ngrx/store';

export const setScheduleOrder = createAction(
              '[Scheluder Component] Scheluder Order',
              props<{show: any}>()
)